import { Container } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ReactComponent as Logo } from 'images/kuberaAuthLogo.svg';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { baseTheme } from 'themes/baseTheme';

import { AuthLayoutAppBar } from './AuthLayoutAppBar/AuthLayoutAppBar';

type Props = { children: React.ReactNode; title: string };

export const AuthLayout: React.FC<Props> = ({ children, title }) => {
  return (
    <ThemeProvider theme={createTheme(baseTheme)}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <AuthLayoutAppBar />
        <Box sx={{ marginBottom: '24px' }}>
          <Logo />
        </Box>
        <Typography
          color="text.secondary"
          sx={{ textAlign: 'center', marginBottom: '24px' }}
          variant="body1"
        >
          {title}
        </Typography>
        {children}
      </Container>
    </ThemeProvider>
  );
};
